import React from "react";
import ThreatIncidentDetail from "components/newDesign/threats/ThreatIncidentDetail";

const ThreatIncidentDetailPage = () => {
  return <ThreatIncidentDetail />;
};

export default ThreatIncidentDetailPage;
